import React from 'react';
import {
  Button,
  Icon,
  Header,
  Segment,
} from 'semantic-ui-react';

export default function RemoteSuccess(props) {
  return (
    <Segment padded textAlign="center">
      <Icon
        name="circle check"
        size="massive"
        color="green"
      />
      <Header
        content="Success"
        subheader={`The contract has been sent to ${props.email}`}
        size="huge"
      />
      <Button
        as="a"
        href={`/dealer/contracts`}
        content="Close"
        basic
        style={{
          marginTop: '15px'
        }}
      />
    </Segment>
  );
}
